import { Box } from '@rover/kibble/core';

import { sanitizeHTML } from '../HTMLText/sanitizeHTML';

import { Props } from './HTMLBox.common';

const HTMLBox = ({ text, ...other }: Props): JSX.Element => {
  return (
    /* @ts-expect-error eslint-disable-next-line react/no-danger */
    <Box dangerouslySetInnerHTML={{ __html: sanitizeHTML(text) }} {...other} />
  );
};

export default HTMLBox;
